import { Map } from "immutable";
import { SAVE_SELECTION_VALUE,CHANGE_VERFICATION_STATE } from "../actions/createRelocation";

const initialState = Map({
  Verfication: [
    {
      "Current Work Address": {
        "Address Line 1": "",
        "Address Line 2": "",
        Suburb: "",
        State: "",
        Postcode: "",
        Country: ""
      }
    },
    {
      "Destination Work Address": {
        "Address Line 1": "",
        "Address Line 2": "",
        Suburb: "",
        State: "",
        Postcode: "",
        Country: "",
        "Estimated Arrival Date": ""
      }
    },
  ],
  showVerfication:false
});

const actionsMap = {
  [SAVE_SELECTION_VALUE]: (state, action) => {
    let param = {};
    let key = "";
    const data = action.data;
    const verfication = state.get("Verfication");
    if (data["Destination Work Address"] !== undefined) {
      key = "Destination Work Address";
      param = data["Destination Work Address"];
    } else {
      key = "Current Work Address";
      param = data["Current Work Address"];
    }
    const currentVerfication = verfication.map(val => {
      const obj = val[key];
      if (obj !== undefined) {
        const key = Object.keys(param);
        const value = Object.values(param);
        obj[key] = value.join("");
      }
      return val;
    });
    return state.set("Verfication", currentVerfication);
  },
  [CHANGE_VERFICATION_STATE]: (state, action) => {
    return state.set('showVerfication', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
